import BaseStore from '../base-store'
let options = {}
export default new BaseStore('artists', options)



// WEBPACK FOOTER //
// ./src/store/modules/artists.store.js